import ArchivedSection from './ArchivedSection';

export default ArchivedSection;
